export const BRAND = {
  name: 'Unity Consulting',
  claim: 'Assicurazioni più semplici, decisioni più consapevoli.',
  logoExtended: '/assets/logo-extended.svg',
  logoMark: '/assets/logo-mark.svg',
};


export const AREAS = [
  {
    key: 'salute',
    name: 'Cassa Malati',
    path: '/cassa-malati',
    icon: 'HeartPulse',
    short: 'Cassa malati obbligatoria e complementari, maternità, cambio cassa: le decisioni sanitarie prese con calma e con i dati alla mano.',
    image: '/assets/soluzione-salute.png',
  },
  {
    key: 'privati',
    name: 'Privati',
    path: '/soluzioni/privati',
    icon: 'Home',
    short: 'Responsabilità civile, mobilia domestica, veicoli, abitazione: la protezione quotidiana di persone e famiglie, nei momenti di cambiamento.',
    image: '/assets/soluzione-privati.png',
  },
  {
    key: 'aziende',
    name: 'Aziende',
    path: '/soluzioni/aziende',
    icon: 'Building2',
    short: 'Dall\u2019apertura alla crescita: mappiamo i rischi operativi dell\u2019impresa e costruiamo un programma assicurativo coerente.',
    image: '/assets/soluzione-aziende.png',
  },
  {
    key: 'previdenza',
    name: 'Previdenza',
    path: '/soluzioni/previdenza',
    icon: 'PiggyBank',
    short: 'Proteggere il reddito di domani: pilastri, incapacità di guadagno, risparmio e pianificazione coordinata.',
    image: '/assets/soluzione-previdenza.png',
  },
];

export const NAV = [
  { label: 'Home', href: '/' },
  {
    label: 'Soluzioni',
    href: '/soluzioni',
    children: [
      { label: 'Panoramica', href: '/soluzioni', description: 'Le quattro aree e il nostro metodo di analisi.' },
      { label: 'Cassa Malati', href: '/cassa-malati', description: 'LAMal, complementari, infortuni e reddito.' },
      { label: 'Privati', href: '/soluzioni/privati', description: 'Casa, famiglia, mobilità e patrimonio.' },
      { label: 'Aziende', href: '/soluzioni/aziende', description: 'Persone, responsabilità e continuità.' },
      { label: 'Previdenza', href: '/soluzioni/previdenza', description: 'LPP, lacune, 3a/3b e pensionamento.' },
    ],
  },
  {
    label: 'Guide',
    href: '/guide',
    children: [
      { label: 'Trasferirsi in Svizzera', href: '/guide/privati/trasferirsi-in-svizzera' },
      { label: 'Andare a vivere da soli', href: '/guide/privati/andare-a-vivere-da-soli' },
      { label: 'Comprare casa a 30 anni', href: '/guide/privati/comprare-casa-a-30-anni' },
      { label: 'Mettersi in proprio', href: '/guide/privati/mettersi-in-proprio' },
      { label: 'Importare un\u2019auto in Svizzera', href: '/guide/privati/importare-auto-in-svizzera' },
      { label: 'Cambio cassa malati', href: '/guide/salute/cambio-cassa-malati-premi-disdetta' },
      { label: 'Assicurazione prenatale', href: '/guide/salute/assicurazione-prenatale' },
      { label: 'Aprire un\u2019azienda', href: '/guide/aziende/aprire-un-azienda' },
      { label: 'Forme giuridiche', href: '/guide/aziende/forme-giuridiche-svizzera' },
    ],
  },
  { label: 'Centro sinistri', href: '/centro-sinistri' },
  { label: 'Chi siamo', href: '/chi-siamo' },
  { label: 'Consiglio a terzi', href: '/consiglio-a-terzi' },
  { label: 'Contatti', href: '/contatti' },
];

export const HOME_FAQ = [
  { q: 'Quanto costa una consulenza?', a: 'Il primo colloquio conoscitivo è gratuito e senza impegno. Prima di qualsiasi incarico ti spieghiamo con chiarezza come lavoriamo e come viene remunerato il nostro servizio.' },
  { q: 'Posso far verificare contratti già esistenti?', a: 'Sì. La verifica delle coperture esistenti è una parte centrale del nostro lavoro: controlliamo doppioni, lacune e condizioni, poi ti presentiamo le alternative in modo comprensibile.' },
  { q: 'Lavorate con privati e aziende?', a: 'Sì, seguiamo sia persone e famiglie sia imprese di diverse dimensioni, dall\u2019apertura dell\u2019attività alla revisione periodica del programma assicurativo.' },
  { q: 'Mi aiutate anche in caso di sinistro?', a: 'Sì. In caso di sinistro ti aiutiamo a raccogliere le informazioni, a evitare gli errori più comuni e a dialogare con la compagnia. Puoi partire dal nostro Centro sinistri.' },
  { q: 'Posso richiedere una consulenza online?', a: 'Sì, offriamo colloqui telefonici e videochiamate, oltre agli incontri in ufficio. Puoi indicare la modalità che preferisci nel modulo di contatto.' },
];

export const LEGAL_PAGES = {
  '/privacy': {
    title: 'Privacy Policy',
    updated: '15 agosto 2026',
    intro: 'Questa informativa descrive come Unity Consulting tratta i dati personali attraverso il sito, quali tecnologie sono effettivamente integrate nel codice attuale e quali scelte sono disponibili agli utenti.',
    sections: [
      {
        title: '1. Titolare del trattamento',
        paragraphs: [
          'Il titolare del trattamento e\u0300 Unity Consulting di Matteo Vairani, impresa individuale con sede in Via Antonio Chiesa 12a, 6830 Chiasso (Svizzera), IDI CHE-275.494.791. Per richieste relative alla protezione dei dati puoi utilizzare i recapiti o il modulo disponibili nella pagina Contatti.',
          'Il trattamento e\u0300 effettuato nel rispetto della Legge federale sulla protezione dei dati (LPD) e delle altre norme svizzere applicabili. Il GDPR viene considerato nella misura in cui risulti applicabile a uno specifico trattamento o a una specifica persona interessata.',
        ],
      },
      {
        title: '2. Dati trattati attraverso il sito',
        paragraphs: [
          'Durante la normale erogazione del sito, l\u2019infrastruttura di hosting puo\u0300 trattare dati tecnici necessari alla consegna e alla sicurezza del servizio, ad esempio indirizzo IP, data e ora della richiesta, URL richiesto, user agent, informazioni sul dispositivo e dati tecnici analoghi.',
          'I moduli di contatto, consiglio a terzi e segnalazione sinistri raccolgono, a seconda del modulo, nome, cognome, recapiti, argomento, messaggio, dati della persona segnalata e informazioni relative a un eventuale sinistro, inclusi i documenti caricati. I dati vengono trasmessi in modo cifrato all\u2019infrastruttura di Unity Consulting per prendere in carico e gestire la richiesta; i moduli di contatto e consiglio a terzi inviano inoltre una conferma all\u2019indirizzo email fornito.',
          'La segnalazione di un sinistro puo\u0300 includere volontariamente dati particolarmente sensibili, ad esempio informazioni sulla salute. Ti invitiamo a trasmettere solo i dati effettivamente necessari alla gestione della richiesta.',
        ],
      },
      {
        title: '3. Finalita\u0300 del trattamento',
        items: [
          'erogare il sito, garantirne stabilita\u0300, sicurezza e corretta visualizzazione;',
          'gestire richieste di contatto o di consulenza quando viene utilizzato un canale di comunicazione effettivamente attivo;',
          'gestire segnalazioni di sinistro e, quando necessario, dialogare con compagnie assicurative o altri soggetti coinvolti nel mandato;',
          'misurare in forma statistica l\u2019utilizzo del sito tramite Google Analytics 4 esclusivamente dopo il consenso;',
          'adempiere obblighi legali, regolamentari o richieste delle autorita\u0300 competenti.',
        ],
        paragraphs: [
          'Quando il GDPR e\u0300 applicabile, i trattamenti strettamente necessari alla gestione di una richiesta possono fondarsi sull\u2019esecuzione di misure precontrattuali o contrattuali, sugli obblighi legali e sugli interessi legittimi applicabili; Google Analytics viene invece attivato sulla base del consenso. Per eventuali dati sensibili inseriti volontariamente in una segnalazione viene richiesto un consenso espresso quando necessario.',
        ],
      },
      {
        title: '4. Google Analytics 4',
        paragraphs: [
          'Il sito integra Google Analytics 4 con ID di misurazione G-B0PCHJ3ETB. L\u2019integrazione e\u0300 configurata in modalita\u0300 opt-in: lo script Google non viene caricato prima della scelta dell\u2019utente e gli eventi di navigazione non vengono inviati ad Analytics senza consenso.',
          'Quando Analytics e\u0300 autorizzato, il sito invia eventi di visualizzazione pagina e Google puo\u0300 trattare informazioni tecniche e di utilizzo, identificatori online, caratteristiche del dispositivo e posizione geografica approssimativa. Nel codice del sito l\u2019archiviazione pubblicitaria, i dati utente per finalita\u0300 pubblicitarie e la personalizzazione degli annunci restano negati; Google Signals e la personalizzazione pubblicitaria sono disattivati.',
          'Google dichiara che, per Google Analytics, l\u2019indirizzo IP viene utilizzato per ricavare dati geografici approssimativi e non viene memorizzato o registrato nei sistemi Analytics. Google puo\u0300 comunque trattare i dati nella propria infrastruttura internazionale secondo i propri termini e meccanismi di trasferimento.',
        ],
      },
      {
        title: '5. Cookie e memorizzazione delle preferenze',
        paragraphs: [
          'Per ricordare la scelta viene utilizzato il cookie proprietario necessario \u201cunity_cookie_consent\u201d, con durata massima di 180 giorni. La stessa preferenza viene memorizzata anche nel localStorage del browser, come copia tecnica di continuita\u0300, con la chiave \u201cunity_cookie_consent_v2\u201d.',
          'Solo dopo il consenso a Google Analytics possono essere creati i cookie proprietari \u201c_ga\u201d e \u201c_ga_<container-id>\u201d. Google indica per entrambi una scadenza predefinita di 2 anni, soggetta ai limiti del browser e alle impostazioni della proprieta\u0300 Analytics.',
          'Puoi rifiutare i cookie analitici senza perdere l\u2019accesso al sito e puoi modificare la decisione in qualsiasi momento tramite \u201cPreferenze cookie\u201d nel footer.',
        ],
      },
      {
        title: '6. Destinatari e trasferimenti all\u2019estero',
        paragraphs: [
          'I dati tecnici necessari all\u2019erogazione del sito possono essere trattati dal fornitore di hosting e da fornitori tecnici incaricati. Quando Google Analytics e\u0300 attivo, i dati vengono trattati da Google e dai relativi subfornitori secondo la documentazione contrattuale e privacy del servizio.',
          'L\u2019utilizzo di servizi internazionali puo\u0300 comportare trattamenti al di fuori della Svizzera. In tali casi si applicano, a seconda della destinazione e del fornitore, decisioni di adeguatezza, framework riconosciuti o altre garanzie previste dalla normativa applicabile, incluse clausole contrattuali standard quando necessarie.',
        ],
      },
      {
        title: '7. Conservazione',
        paragraphs: [
          'I dati sono conservati solo per il tempo necessario alle finalita\u0300 per cui sono trattati e agli obblighi legali applicabili. I log tecnici dipendono dalla configurazione dell\u2019hosting e dalle esigenze di sicurezza. Il consenso cookie viene ricordato per un massimo di 180 giorni.',
          'Per Google Analytics, la durata dei dati associati a cookie e identificatori dipende dalle impostazioni effettive della proprieta\u0300 GA4; i cookie GA4 hanno una durata predefinita indicata da Google fino a 2 anni. La configurazione dell\u2019account Analytics deve rimanere coerente con quanto dichiarato in questa informativa.',
        ],
      },
      {
        title: '8. Diritti delle persone interessate',
        paragraphs: [
          'Nei limiti previsti dalla legge puoi chiedere conferma del trattamento, accesso ai dati, rettifica, cancellazione, limitazione o opposizione e, quando applicabile, consegna o portabilita\u0300 dei dati. Se il trattamento si basa sul consenso, puoi revocarlo in qualsiasi momento senza pregiudicare la liceita\u0300 del trattamento precedente.',
          'Puoi inoltre rivolgerti all\u2019Incaricato federale della protezione dei dati e della trasparenza (IFPDT) o, quando il GDPR e\u0300 applicabile, all\u2019autorita\u0300 di controllo competente.',
        ],
      },
      {
        title: '9. Sicurezza e aggiornamenti',
        paragraphs: [
          'Unity Consulting adotta misure tecniche e organizzative adeguate al rischio per proteggere i dati da accessi non autorizzati, perdita, alterazione o divulgazione indebita. Nessuna trasmissione via Internet puo\u0300 tuttavia essere garantita come assolutamente sicura.',
          'Questa informativa viene aggiornata quando cambiano il sito, i fornitori o i trattamenti. La data di ultima revisione e\u0300 indicata in cima alla pagina.',
        ],
      },
    ],
    resources: [
      { label: 'IFPDT - Obbligo di informare e protezione dei dati', href: 'https://www.edoeb.admin.ch/it' },
      { label: 'Google - Informativa sulla privacy', href: 'https://policies.google.com/privacy?hl=it' },
      { label: 'Google Analytics - Privacy e dati', href: 'https://support.google.com/analytics/topic/2919631?hl=it' },
    ],
  },
  '/cookie-policy': {
    title: 'Cookie Policy',
    updated: '15 agosto 2026',
    intro: 'Questa Cookie Policy descrive esclusivamente le tecnologie rilevate nell\u2019attuale codice del sito: una preferenza tecnica necessaria e, previo consenso, Google Analytics 4.',
    sections: [
      {
        title: '1. Cosa utilizza il sito',
        paragraphs: [
          'Il sito non necessita di cookie pubblicitari o di marketing per funzionare. La scelta dell\u2019utente viene ricordata con una tecnologia necessaria; Google Analytics 4 e\u0300 invece facoltativo e resta bloccato fino al consenso.',
        ],
      },
      {
        title: '2. Tecnologia necessaria per il consenso',
        items: [
          'unity_cookie_consent - fornitore: Unity Consulting; finalita\u0300: ricordare se Analytics e\u0300 stato accettato o rifiutato; durata massima: 180 giorni; categoria: necessario.',
          'unity_cookie_consent_v2 - localStorage; finalita\u0300: conservare una copia tecnica della preferenza di consenso e ripristinarla quando il cookie non e\u0300 disponibile; durata: fino alla cancellazione manuale o alla sovrascrittura della preferenza; categoria: necessario.',
        ],
        paragraphs: [
          'Queste tecnologie non vengono usate per profilazione, pubblicita\u0300 o misurazione dell\u2019audience.',
        ],
      },
      {
        title: '3. Google Analytics 4 - facoltativo',
        items: [
          '_ga - fornitore: Google Analytics; finalita\u0300: distinguere gli utenti; scadenza predefinita indicata da Google: 2 anni.',
          '_ga_<container-id> - fornitore: Google Analytics; finalita\u0300: mantenere lo stato della sessione; scadenza predefinita indicata da Google: 2 anni.',
        ],
        paragraphs: [
          'Il tag gtag.js con ID G-B0PCHJ3ETB viene caricato solo dopo il consenso. Il sito non abilita Google Signals, personalizzazione pubblicitaria, ad_storage, ad_user_data o ad_personalization.',
          'I domini tecnici coinvolti possono includere googletagmanager.com e google-analytics.com. La durata effettiva dei cookie puo\u0300 essere ridotta dal browser o dalle impostazioni della proprieta\u0300 Google Analytics.',
        ],
      },
      {
        title: '4. Come funziona il banner',
        paragraphs: [
          'Alla prima visita puoi scegliere \u201cSolo necessari\u201d, \u201cPersonalizza\u201d oppure \u201cAccetta analitici\u201d. Nella schermata di personalizzazione, i necessari sono sempre attivi e Analytics e\u0300 disattivato per impostazione predefinita finche\u0300 non viene selezionato.',
          'Il rifiuto non limita l\u2019accesso ai contenuti. La scelta puo\u0300 essere cambiata in qualsiasi momento tramite \u201cPreferenze cookie\u201d nel footer. In caso di revoca, il sito blocca i nuovi eventi Analytics e tenta di eliminare i cookie GA4 accessibili dal dominio corrente.',
        ],
      },
      {
        title: '5. Controlli del browser e modifiche future',
        paragraphs: [
          'Puoi inoltre cancellare cookie e localStorage dalle impostazioni del browser. La cancellazione della preferenza fara\u0300 ricomparire il banner alla visita successiva.',
          'Se in futuro verranno aggiunti video incorporati, mappe, pixel pubblicitari, chat, strumenti di marketing o altri servizi di terze parti, dovranno essere valutati e, ove necessario, bloccati prima del consenso e descritti in questa pagina.',
        ],
      },
    ],
    resources: [
      { label: 'Google Analytics - Utilizzo dei cookie sui siti web', href: 'https://support.google.com/analytics/answer/11397207?hl=it' },
      { label: 'Google - Consent Mode', href: 'https://support.google.com/analytics/answer/10000067?hl=it' },
      { label: 'Google - Informativa sulla privacy', href: 'https://policies.google.com/privacy?hl=it' },
    ],
  },
  '/note-legali': {
    title: 'Note legali',
    updated: '15 agosto 2026',
    intro: 'Le presenti note identificano il gestore del sito e delimitano la natura informativa dei contenuti pubblicati da Unity Consulting.',
    finmaRegistration: {
      label: 'Numero di registrazione FINMA',
      number: 'F01574165',
      href: 'https://www.finma.ch/it/autorizzazione/intermediazione-assicurativa/registersuche/',
    },
    sections: [
      {
        title: '1. Gestore del sito',
        paragraphs: [
          'Unity Consulting di Matteo Vairani, impresa individuale, Via Antonio Chiesa 12a, 6830 Chiasso, Svizzera. IDI: CHE-275.494.791. Registro di commercio del Cantone Ticino: CH-501.1.024.806-4.',
          'L\u2019attivita\u0300 dichiarata comprende consulenza, intermediazione e gestione in ambito assicurativo e finanziario, nonche\u0301 attivita\u0300 connesse di pianificazione e gestione dei rischi per clienti privati e aziendali.',
        ],
      },
      {
        title: '2. Intermediazione assicurativa',
        paragraphs: [
          'Per l\u2019attivita\u0300 di intermediazione assicurativa si applicano la Legge sulla sorveglianza degli assicuratori (LSA) e la relativa regolamentazione. Le informazioni obbligatorie previste per l\u2019intermediario, incluse quelle rilevanti ai sensi degli articoli 45, 45a e 45b LSA, vengono fornite al cliente nelle forme e nei tempi previsti prima della conclusione di un contratto o nell\u2019ambito del rapporto di consulenza.',
          'Il numero di registrazione FINMA pubblicato dal sito e\u0300 F01574165. Lo stato dell\u2019iscrizione puo\u0300 essere verificato nel registro pubblico FINMA tramite il collegamento riportato in questa pagina.',
        ],
      },
      {
        title: '3. Natura dei contenuti',
        paragraphs: [
          'Le informazioni, guide, esempi, checklist e confronti presenti sul sito hanno finalita\u0300 generali e informative. Non costituiscono, da soli, consulenza assicurativa, finanziaria, fiscale o legale personalizzata, ne\u0301 un\u2019offerta vincolante o una raccomandazione di acquisto.',
          'Premi, condizioni, coperture, esclusioni, termini di disdetta, requisiti e norme possono cambiare. Per ogni decisione concreta devono essere verificati i documenti contrattuali aggiornati, le condizioni della compagnia e la situazione individuale del cliente.',
        ],
      },
      {
        title: '4. Accuratezza e responsabilita\u0300',
        paragraphs: [
          'Unity Consulting cura i contenuti con attenzione, ma non garantisce che ogni pagina sia in ogni momento completa, priva di errori o aggiornata rispetto a modifiche legislative, regolamentari, tariffarie o contrattuali intervenute successivamente alla revisione indicata.',
          'Nei limiti consentiti dalla legge, Unity Consulting non risponde di decisioni prese esclusivamente sulla base dei contenuti generali del sito ne\u0301 di indisponibilita\u0300 temporanee, errori tecnici o contenuti di siti esterni collegati.',
        ],
      },
      {
        title: '5. Link esterni',
        paragraphs: [
          'I collegamenti a FINMA, autorita\u0300, compagnie, fornitori o altri siti sono forniti per comodita\u0300. Unity Consulting non controlla permanentemente i contenuti, la disponibilita\u0300 o le pratiche privacy di tali siti; quando li visiti si applicano le condizioni del rispettivo gestore.',
        ],
      },
      {
        title: '6. Proprieta\u0300 intellettuale',
        paragraphs: [
          'Salvo diversa indicazione, testi, struttura editoriale, elementi grafici e contenuti originali del sito sono protetti dalle norme applicabili in materia di diritto d\u2019autore e altri diritti di proprieta\u0300 intellettuale. Marchi, loghi e materiali di terzi restano di proprieta\u0300 dei rispettivi titolari.',
          'La riproduzione, pubblicazione o riutilizzazione sostanziale dei contenuti oltre gli usi consentiti dalla legge richiede l\u2019autorizzazione del titolare dei relativi diritti.',
        ],
      },
      {
        title: '7. Diritto applicabile',
        paragraphs: [
          'Il sito e le presenti note sono soggetti al diritto svizzero, fatti salvi i diritti inderogabili eventualmente applicabili alla persona interessata o al cliente. Per i rapporti contrattuali fanno fede anche gli accordi e i documenti specifici sottoscritti dalle parti.',
        ],
      },
    ],
    resources: [
      { label: 'Registro pubblico FINMA degli intermediari assicurativi', href: 'https://www.finma.ch/it/autorizzazione/intermediazione-assicurativa/registersuche/' },
      { label: 'Indice centrale delle ditte Zefix', href: 'https://www.zefix.ch/it/search/entity/list/firm/1623719' },
    ],
  },
};

export const GUIDE_IMAGES = {
  '/cassa-malati/cassa-malati-obbligatoria': '/assets/guides/lamal.jpg',
  '/cassa-malati/cassa-malati-facoltativa': '/assets/guides/complementari.jpg',
  '/guide/salute/cambio-cassa-malati-premi-disdetta': '/assets/guides/cambio-cassa.jpg',
  '/guide/salute/assicurazione-prenatale': '/assets/guides/prenatale.jpg',
  '/guide/privati/trasferirsi-in-svizzera': '/assets/guides/trasferirsi-svizzera-v2.webp',
  '/guide/privati/andare-a-vivere-da-soli': '/assets/guides/vivere-soli.jpg',
  '/guide/privati/comprare-casa-a-30-anni': '/assets/guides/comprare-casa.jpg',
  '/guide/privati/importare-auto-in-svizzera': '/assets/guides/importare-auto.jpg',
  '/guide/privati/mettersi-in-proprio': '/assets/guides/mettersi-in-proprio.jpg',
  '/guide/aziende/aprire-un-azienda': '/assets/guides/aprire-azienda.jpg',
  '/guide/aziende/forme-giuridiche-svizzera': '/assets/guides/forme-giuridiche.jpg',
  '/soluzioni/aziende/tipologie-assicurazioni': '/assets/guides/tipologie-aziende.jpg',
};

export const GUIDE_HIGHLIGHTS = [
  '/guide/privati/trasferirsi-in-svizzera',
  '/guide/salute/assicurazione-prenatale',
];

export const DISCLAIMER = 'I contenuti di questa pagina sono informativi e non sostituiscono una consulenza individuale. Condizioni, premi, termini di disdetta e coperture vanno sempre verificati sul contratto e presso la compagnia interessata.';
